

<template>
  <div class="container">
    <div @click="$router.back()">
      <i class="el-icon-arrow-left"></i>
    </div>
    <div class="title">
      {{ $t('Privacy.title') }}
    </div>
    <div style="white-space: pre-line;padding: 0 3em">
      {{ $t('Privacy.content') }}
    </div>
  </div>
</template>
<script>

export default {
  name: 'privacyPolicy',
  data () {
    return {
    path:'1'
    }
  },
  created () {
  },
  methods: {

  },
  mounted () {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped>
.container {
  padding: 1em;
  font-size: 1.5em;
  text-indent: 2em;
}

.title {
  margin: 1em;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/privacyPolicy.vue